import React from 'react';
import { Card } from '../ui/Card';
import { formatNumber } from '../../utils/formatters';
import clsx from 'clsx';

interface KPICardProps {
  title: string;
  value: number;
  unit?: string;
  icon?: string;
  trend?: 'up' | 'down';
  trendValue?: string;
  color?: 'blue' | 'green' | 'orange' | 'red';
  subtitle?: string;
}

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  unit = '',
  icon,
  trend,
  trendValue,
  color = 'blue',
  subtitle,
}) => {
  const colorClasses = {
    blue: 'text-primary-500',
    green: 'text-professional-500',
    orange: 'text-personal-500',
    red: 'text-red-500',
  };

  return (
    <Card>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-600 mb-2">
            {icon && <span className="text-lg">{icon}</span>}
            <span>{title}</span>
          </div>
          <div className={clsx('text-3xl font-bold', colorClasses[color])}>
            {formatNumber(value)}
            {unit && <span className="text-xl ml-1 text-gray-600">{unit}</span>}
          </div>
          {subtitle && <div className="mt-1 text-sm text-gray-500">{subtitle}</div>}
        </div>
      </div>
      {trend && trendValue && (
        <div className="mt-4 flex items-center gap-1">
          <span
            className={clsx(
              'text-sm font-medium',
              trend === 'up' ? 'text-green-600' : 'text-red-600'
            )}
          >
            {trend === 'up' ? '↗' : '↘'} {trendValue}
          </span>
          <span className="text-sm text-gray-500">vs last month</span>
        </div>
      )}
    </Card>
  );
};
